module.exports = __webpack_public_path__ + "media/images/crime-by-county-1ea38134d261e62ca6c47f70c852c204.png";